import React from 'react';

// Simple dependency-free Tooltip implementation using Tailwind CSS
// Mimics the Radix UI structure used in the project

export const TooltipProvider = ({ children }) => <>{children}</>;

export const Tooltip = ({ children }) => (
    <div className="relative inline-flex group align-middle">
        {children}
    </div>
);

export const TooltipTrigger = ({ children }) => <>{children}</>;

export const TooltipContent = ({ children }) => (
    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-slate-900 rounded opacity-0 group-hover:opacity-100 transition-opacity z-50 pointer-events-none whitespace-nowrap shadow-md">
        {children}
        {/* Tiny arrow */}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-900"></div>
    </div>
);
